import Component from '../core/Component'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

const STATES = {
	ACTIVE: 'is-active',
	READY: 'is-ready',
}

export default class PopupNavOpener extends Component {
	constructor(element, options = {}) {
		super(element, options)

		this.ref = {
			hamburger: null,
		}
	}

	prepare() {
		this.element.addEventListener('click', this.handleClick)
		EventBus.on(EVENTS.POPUPNAV_OPENED, this.handlePopupNavOpened)
		EventBus.on(EVENTS.POPUPNAV_CLOSED, this.handlePopupNavClosed)
		this.element.classList.add(STATES.READY)
	}

	destroy() {
		EventBus.off(EVENTS.POPUPNAV_OPENED, this.handlePopupNavOpened)
	}

	handlePopupNavOpened = () => {
		this.element.classList.add(STATES.ACTIVE)
		this.ref.hamburger?.classList.add('is-active')
	}

	handlePopupNavClosed = () => {
		this.element.classList.remove(STATES.ACTIVE)
		this.ref.hamburger?.classList.remove('is-active')
	}

	handleClick = (event) => {
		event.preventDefault()
		EventBus.emit(EVENTS.POPUPNAV_TOGGLE)
	}
}
